import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const recipesV2AccessControl: DomainAccessControlConfig = {
  permissions: [Permission.RecipesView],
  minICPlatformVersion: ICPlatformVersion.r2026_12_0,
}

export const recipesV2ModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.RecipesModify],
  minICPlatformVersion: ICPlatformVersion.r2026_12_0,
}
